import dayjs from 'dayjs'

export function advanceParseDate (value: string, format: string) {
  let parseDate = dayjs(value, format)

  if (!parseDate.isValid()) {
    const simpleFormat = (format.match(/[a-zA-Z]+/g) as string[]).join('')

    parseDate = dayjs(value, simpleFormat)
  }

  return parseDate
}
